import clsx from 'clsx';
import React from 'react';

import BaseButton, { BaseButtonProps } from '../../BaseButton/BaseButton';
import styles from './BottomSheetContentsSelect.module.scss';

const Container: React.FC = ({ children }) => <ul className={styles.container}>{children}</ul>;

type CellProps = BaseButtonProps & { isFullCell?: boolean };
const Cell: React.FC<CellProps> = ({ className, isFullCell, ...props }) => (
  <li className={clsx(styles.cell, isFullCell && styles.fullCell)}>
    <BaseButton className={clsx(styles.cellInteractor, className)} {...props} />
  </li>
);

export default {
  Container,
  Cell,
};
